import { Components } from '@mui/material/styles';
import hexToRGBA from 'theme/hexToRGBA';
import palette from 'theme/palette';
import { MuiAutocomplete } from './MuiAutocomplete';

import { MuiButton } from './MuiButton';
import { MuiIconButton } from './MuiIconButton';
import { MuiMenu, MuiMenuItem } from './MuiMenu';
import { MuiSkeleton } from './MuiSkeleton';
import { MuiToggleButtonGroup } from './MuiToggleButtonGroup';
const components: Components = {
  MuiButton,
  MuiIconButton,
  MuiMenu,
  MuiMenuItem,
  MuiSkeleton,
  MuiToggleButtonGroup,

  MuiAutocomplete,
  MuiTextField: {
    styleOverrides: {
      root: {
        'input, textarea': {
          '&:focus': {
            boxShadow: 'initial',
          },
        },
      },
    },
  },
  MuiTooltip: {
    styleOverrides: {
      tooltip: {
        color: palette.primary.main,
        backgroundColor: palette.common.white,
        borderRadius: '10px',
        boxShadow: `4px 4px 10px ${hexToRGBA(palette.common.black, 0.05)}`,
        minHeight: '32px',
        display: 'flex',
        alignItems: 'center',
      },
      arrow: {
        color: palette.common.white,
      },
    },
  },
  MuiCssBaseline: {
    styleOverrides: `
        * {
            font-family: 'Graphik';
        }
      `,
  },
};

export default components;
